import { useState } from 'react'
import { message as $message } from 'antd'
import cloneDeep from 'lodash/cloneDeep'
import { getAfterSelectItem } from '@/services/afterSale'

export default function useExpressInterception() {
    const [querySelects, setQuerySelects] = useState({})

    const handleChildList = data => {
        if (data) {
            return data?.map(item => {
                return {
                    ...item,
                    title: item.value,
                    label: item.value,
                    value: item.code,
                    key: item.code,
                    children: item.childList && handleChildList(item.childList),
                }
            })
        }
    }
    const initSelect = async () => {
        try {
            const { success, data = {}, message } = await getAfterSelectItem({ channel: 'SUPPLIER' })
            if (success) {
                const cloneDate = cloneDeep(data || {})
                for (let key in cloneDate) {
                    // eslint-disable-next-line prefer-object-has-own
                    if (Object.prototype.hasOwnProperty.call(cloneDate, key)) {
                        cloneDate[key] = (cloneDate[key] || []).map(v => {
                            if (typeof v === 'object') {
                                return {
                                    ...v,
                                    label: v.value,
                                    value: v.code,
                                    title: v.value,
                                    key: v.code,
                                    children: v.childList && handleChildList(v.childList),
                                }
                            }
                            if (typeof v === 'string') {
                                return {
                                    label: v,
                                    value: v,
                                }
                            }
                            return v
                        })
                    }
                }
                setQuerySelects(cloneDate)
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error('catchError', error)
        }
    }

    return { querySelects, initSelect }
}
